import {
    AUTH_REQUEST,
    AUTH_ERROR,
    AUTH_SUCCESS,
    AUTH_LOGOUT
} from '../actions/auth'
import {
    authenticate
} from '@/api/login';
import {
    setToken,
    removeToken,
    getToken
} from '@/util/auth'

const state = {
    token: getToken() || '',
    status: '',
    hasLoadedOnce: false
}

const getters = {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status,
}

const actions = {
    [AUTH_REQUEST]: ({
        commit,
        dispatch
    }, user) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_REQUEST)
            authenticate(user)
                .then(resp => {
                    console.log(resp.data)
                    if (resp.data.userId != null) {
                        setToken(resp.data.token)
                        commit(AUTH_SUCCESS, resp)
                        //dispatch(USER_REQUEST)
                        resolve(resp)
                    } else {
                        commit(AUTH_ERROR, 'Incorrect username or password ')
                        removeToken()
                        reject(err)
                    }
                })
                .catch(err => {
                    commit(AUTH_ERROR, err)
                    removeToken()
                    reject(err)
                })
        })
    },
    [AUTH_LOGOUT]: ({
        commit,
        dispatch
    }) => {
        return new Promise((resolve, reject) => {
            commit(AUTH_LOGOUT)
            removeToken()
            resolve()
        })
    }
}

const mutations = {
    [AUTH_REQUEST]: (state) => {
        state.status = 'loading'
    },
    [AUTH_SUCCESS]: (state, resp) => {
        state.status = 'success'
        state.token = resp.data.token
        state.userId = resp.data.userId
        state.userName = resp.data.userName
        state.hasLoadedOnce = true
    },
    [AUTH_ERROR]: (state) => {
        state.status = 'error'
        state.hasLoadedOnce = true
    },
    [AUTH_LOGOUT]: (state) => {
        state.token = ''
        state.status = ''
        state.userId = ''
        state.userName = ''
    }
}

export default {
    state,
    getters,
    actions,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/auth.js